import React from 'react';
import {DataFetcherProvider} from './context';
import {Result} from './types';
import {BotModeProvider} from './BotMode';

export const wrapAppWithDataFetcherProvider = (App: React.ReactElement) => {
  const initialState = getInitialState();
  const hasInitialState = initialState !== null;
  const initialData = initialState ?? new Map();

  return {
    content: (
      <DataFetcherProvider
        initialData={initialData}
        isInitialServerRequest={false}
      >
        <BotModeProvider value={!hasInitialState}>{App}</BotModeProvider>
      </DataFetcherProvider>
    ),
    hasInitialState,
  };
};

const getInitialState = () => {
  const initialStateElement = document.querySelector(
    '[data-tadarida-initial-state]',
  );

  if (!initialStateElement) {
    return null;
  }

  try {
    return new Map<string, Result<unknown>>(
      JSON.parse(initialStateElement.innerHTML),
    );
  } catch (e) {
    console.warn(e);

    return null;
  }
};
